import styled from 'styled-components';

const Wrapper = styled.span`
  width: 100%;
  position: relative;
  display: inline-block;
  text-align: right;
`;

export default Wrapper;

